import { TpDataObjectMatrix } from './interfaces';
import Tabber from '../../../components/panels/tabber/Tabber';
import { renderTable } from './DataObjectTable';

type TpDataObjectMatrixProps = {
  matrix: TpDataObjectMatrix;
};

export function DataObjectMatrix({ matrix }: TpDataObjectMatrixProps) {
  const tabTitles: Map<string, string> = new Map([
    ['featureMetadata', 'Features metadata'],
    ['observationMetadata', 'Observations metadata'],
  ]);

  const renderTabContent = (tabId: string) => {
    const tableColumns = tabId === 'observationMetadata' ? matrix.obsMetadataColumns : matrix.featureMetadataColumns;
    return renderTable(tableColumns);
  };

  return (
    <Tabber // First the feature metadata as that is the most important
      tabIds={['featureMetadata', 'observationMetadata']}
      getHeader={(tabId) => tabTitles.get(tabId) || tabId}
      renderContent={renderTabContent}
      selectionStyle="bold"
      headerStyles={{ marginTop: '1em' }}
    />
  );
}
